import { Transform, type TransformFnParams, Type } from 'class-transformer';
import { ArrayMinSize, IsNotEmpty, IsOptional, IsString, MaxLength, MinLength } from 'class-validator';
import i18next from 'i18next';
import type { Conversation, ConversationType } from './conversation';

export class ConversationCreate {
  conversationType: ConversationType = 'GROUP';

  @IsString()
  @IsNotEmpty({ message: () => i18next.t('conversations.validation.nameRequired') })
  @MinLength(3, { message: () => i18next.t('conversations.validation.nameMinLength') })
  @MaxLength(50, { message: () => i18next.t('conversations.validation.nameMaxLength') })
  conversationName = '';

  @IsOptional()
  @IsString()
  avatarRef?: string;

  @ArrayMinSize(1, { message: () => i18next.t('conversations.validation.membersRequired') })
  participantIds: string[] = [];

  @IsOptional()
  @IsString()
  parentConversationId?: string;

  @IsOptional()
  @IsString()
  metadata?: string;

  @Type(() => Object)
  @Transform(({ obj }: TransformFnParams) => {
    return obj.file as File;
  })
  file?: File;

  constructor(data: Partial<ConversationCreate> = {}) {
    Object.assign(this, data);
  }
}

export interface ConversationListResponse {
  conversations: Conversation[];
  nextPageToken: string | null;
  pageSize: number;
}

export interface ConversationsParams {
  pageToken?: string;
  pageSize?: number;
  search?: string;
}

export interface UpdateConversationRes {
  conversationId: string;
  conversationType: string;
  conversationName: string;
  avatarRef: string;
  createdAt: string;
}

// Search DTOs
export interface ConversationSearchItem {
  id: string;
  conversationName: string;
  conversationType: ConversationType;
  conversationAvatarRef: string | null;
  partnerId: string | null;
  userId: string;
  conversationId: string;
  createdAt: string;
}

export interface ConversationSearchResponse {
  items: ConversationSearchItem[];
  totalCount: number;
  page: number;
  perPage: number;
}
